import React, { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/cart";
import { useLenis, scrollToTop } from "@/lib/scroll";
import Home from "@/pages/Home";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import Admin from "@/pages/Admin";
import Flyer from "@/pages/Flyer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error(error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-[#0B1021]">
          <h1 className="font-display text-3xl text-[#F8F9FA]">Something dimmed the lights</h1>
          <p className="text-[#8A99B5] mt-3">Please refresh the page to return to the event.</p>
          <button onClick={() => window.location.reload()} className="btn-gold rounded-full px-8 py-3.5 text-sm font-bold mt-8">
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop();
  }, [pathname]);
  return null;
};

const App = () => {
  useLenis();
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <CartProvider>
          <ScrollManager />
          <div className="grain-overlay" aria-hidden="true" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/confirmation/:code" element={<Confirmation />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/flyer" element={<Flyer />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Toaster theme="dark" position="top-center" richColors closeButton />
        </CartProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
